import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { RenderFeatureFlag } from '@terminal/components/render-feature-flag/RenderFeatureFlag';
import { useCatalystInsightsList } from '@terminal/react-query-hooks/insights/useCatalystInsights';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { CatalystInsightPill } from '@terminal/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';
import clsx from 'clsx';
import { startOfDay, subDays } from 'date-fns';
import { useMemo } from 'react';
import { ThemeLogoIcon } from '../../../../views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';
import styles from './ThemeHeader.module.scss';

interface ThemeHeaderProps {
  themeId: string;
  themeName: string;
  logo_url?: string;
  isCondensed?: boolean;
}

export const ThemeHeader = ({
  themeId,
  themeName,
  logo_url,
  isCondensed = false,
}: ThemeHeaderProps) => {
  const fromDate = useMemo(() => startOfDay(subDays(new Date(), 3)), []);
  const { data: catalystInsightsData } = useCatalystInsightsList({
    themes: [themeId],
    categories: ['market_wide'],
    from: fromDate.toISOString(),
    page: 1,
    page_size: 1,
  });

  return (
    <div className={styles.flexRow}>
      <div
        className={clsx(styles.logoAndTitle, {
          [styles.condensed]: isCondensed,
        })}
      >
        <ThemeLogoIcon logo_url={logo_url} name={themeName} key={themeName} />
        <span
          className={clsx(styles.titleText, {
            [styles.condensed]: isCondensed,
          })}
        >
          {themeName}
        </span>
      </div>
      <div className={styles.rightCluster}>
        {!!catalystInsightsData?.length && (
          <CatalystInsightPill
            insightId={catalystInsightsData[0].id}
            themeId={themeId}
            subCategory={catalystInsightsData[0].sub_category}
            isClickable
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
            category={catalystInsightsData[0].category}
          />
        )}
        <RenderFeatureFlag requiredFlag="followed_themes">
          <FollowThemeButton themeId={themeId} />
        </RenderFeatureFlag>
      </div>
    </div>
  );
};
